import { Injectable, ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';


@Injectable()
export class DwDapHttpErrorHandler {

  constructor(private route: Router) {

  }

  handlerError(error: HttpErrorResponse): void {
    const msg = error.error;
    if (msg.errorType !== 'System') {
      return;
    }

    if (msg.status === 400) {
      if (msg.errorMessage.indexOf('Method 不允許匿名') !== -1) {
        this.route.navigate(['/login']);
      }
    }
  }
}
